'use strict';

Object.defineProperty(exports, '__esModule', {
  value: true
});
exports['default'] = Col;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) arr2[i] = arr[i]; return arr2; } else { return Array.from(arr); } }

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

function Col(_ref) {
  var children = _ref.children;
  var _ref$className = _ref.className;
  var className = _ref$className === undefined ? '' : _ref$className;
  var _ref$style = _ref.style;
  var style = _ref$style === undefined ? {} : _ref$style;
  var _ref$type = _ref.type;
  var type = _ref$type === undefined ? '' : _ref$type;

  return _react2['default'].createElement(
    'div',
    { className: _classnames2['default'].apply(undefined, [className].concat(_toConsumableArray(type.split(' ').map(function (col) {
        return 'col-' + col;
      })))), style: style },
    children
  );
}

module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./lib/components/col.js
// module id = 314
// module chunks = 0